enum Locale {
  English = 'en-US',
  Spanish = 'es-ES',
  French = 'fr-FR',
  German = 'de-DE',
  Italian = 'it-IT',
  BrazilPortuguese = 'pt-BR',
  Korean = 'ko-KR',
  SimplifiedChinese = 'zh-CN',
  SimplifiedChineseJV = 'zh-CJV',
  TraditionalChinese = 'zh-TW',
  Japanese = 'ja-JP',
  Russian = 'ru-RU',
  Indonesian = 'id-ID',
  Polish = 'pl-PL',
  Vietnamese = 'vi-VN',
  Turkish = 'tr-TR',
  Arabic = 'ar-001',
  Thai = 'th-TH',
}

export default Locale;
